import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-48c1827a")

_pushScopeId("data-v-48c1827a")
const _hoisted_1 = {
  class: "relative dialog-content p-6",
  ref: "dialogContent"
}
const _hoisted_2 = { class: "flex items-center font-size-24 mb-7" }
const _hoisted_3 = { class: "text-center break-all" }
const _hoisted_4 = {
  class: "mb-6 break-words",
  style: {"display":"block"}
}
const _hoisted_5 = { class: "flex justify-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BaseIcon = _resolveComponent("BaseIcon")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    ($setup.optionDelete.isShown)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "dialog-container",
          tabindex: "0",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clickOutside($event)))
        }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_BaseIcon, {
                name: "warning",
                class: "mr-4"
              }),
              _createVNode("div", _hoisted_3, _toDisplayString($setup.optionDelete.title || $setup.t('areYouSureDeleteTitle')), 1)
            ]),
            _createVNode("div", _hoisted_4, _toDisplayString($setup.optionDelete.body || $setup.t('areYouSureDeleteBody')), 1),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_Button, {
                variant: "outline-danger",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onDelete($setup.optionDelete.onSubmit))),
                class: "w-50 h-12"
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString($setup.optionDelete.btnOnSubmitText || $setup.t('actionDelete')), 1)
                ]),
                _: 1
              })
            ])
          ], 512)
        ]))
      : _createCommentVNode("", true)
  ]))
})